import React from "react";
import { useTranslation } from "react-i18next";
import EditAccountability from "../edit-accountability";
import SelectDays from "../inputs/select-days";
import SvgIcon from "../SvgIcon";

const AccountabilityCard = ({
  id,
  setState,
  state,
  changeOrder,
  handleEditing,
  removeItem,
  adding,
  startingCalendarDay = 0,
}) => {
  const { t } = useTranslation("common");
  const setDays = (day) => {
    setState(
      state.map((item, i) => {
        return i === id
          ? {
              ...item,
              days: {
                ...item.days,
                [day]: !item.days[day],
              },
            }
          : item;
      })
    );
  };
  if (state[id].editing)
    return (
      <EditAccountability
        state={state}
        setState={setState}
        id={id}
        setDays={setDays}
        removeItem={() => (changeOrder ? null : removeItem(id))}
        adding={adding}
        startingCalendarDay={startingCalendarDay}
      />
    );
  return (
    <div
      className="accountability-card-container item-grabber-container"
      id={state[id]._id}
      key={state[id]._id}
    >
      <div className="accountability-card ">
        <div>
          <p className="s3">{state[id].title}</p>
          <p className="p4">{state[id].description}</p>
        </div>
        <div className="acc-right-card">
          <SelectDays
            days={state[id].days}
            setDays={setDays}
            startingCalendarDay={startingCalendarDay}
          />
          {!changeOrder && (
            <div className="accountability-btns">
              <button
                data-button-type="secondary"
                data-icon-only
                data-icon
                onClick={() => {
                  !changeOrder ? handleEditing(id) : null;
                }}
              >
                <SvgIcon src="/img/new-icons/edit-pencil.svg" alt={t("edit")} />
              </button>
              <button
                data-button-type="secondary"
                data-icon-only
                data-icon
                onClick={changeOrder ? null : () => removeItem(id)}
                type="button"
              >
                <SvgIcon
                  src="/img/new-icons/red-trash.svg"
                  alt={t("delete")}
                  noFilterOnLight={true}
                />
              </button>
            </div>
          )}
        </div>
      </div>
      {changeOrder && (
        <div className="drag-handle">
          <SvgIcon src="/img/new-icons/menu.svg" alt={t("grab")} />
        </div>
      )}
    </div>
  );
};

export default AccountabilityCard;
